import * as React from "react";

import { motion } from "framer-motion";
import { Card, CardContent } from "./ui/card";
import { Link } from "react-router-dom";

const StatCard = ({ title, value, icon: Icon, color, trend, link }) => {
  const trendColor = trend > 0 ? "text-red-500" : "text-red-500";
  const trendSymbol = trend > 0 ? "↑" : "↓";

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Card className="hover:shadow-foreground shadow-sm  transition-shadow bg-card  text-card-foreground">
        <CardContent className="p-6">
          <Link to={link}>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs font-medium text-gray-500 text-muted-foreground">
                  {title}
                </p>
                <h3
                  className={`text-2xl font-bold mt-2 ${
                    color.includes("red")
                      ? "text-red-500"
                      : color.includes("red")
                        ? "text-red-500"
                        : "text-blue-500"
                  }`}
                >
                  {value}
                </h3>
                {trend !== undefined && (
                  <p className={`text-sm ${trendColor} mt-1`}>
                    {trendSymbol} {Math.abs(trend)}%
                  </p>
                )}
              </div>
              <div
                className={`p-3 rounded-full ${
                  color.includes("red")
                    ? "bg-red-100 dark:bg-red-900"
                    : color.includes("red")
                      ? "bg-red-100 dark:bg-red-900"
                      : "bg-blue-100 dark:bg-blue-900"
                }`}
              >
                <Icon
                  className={`w-6 h-6 ${
                    color.includes("red")
                      ? "text-red-500"
                      : color.includes("red")
                        ? "text-red-500"
                        : "text-blue-500"
                  }`}
                />
              </div>
            </div>
          </Link>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default StatCard;
